define.alias("shared/helpers/format-date", "settings/helpers/format-date");